import React, { useEffect, useState } from 'react'

const PopUp = ({ isOpen, closeModal,setIsModalOpen,setTaxes }) => {

    const[key,setkey] = useState('')
    const[value,setValue] = useState(0)

    const addTax = () =>{
        setTaxes((prev) => [
            ...prev,
            {taxType:key,rate:value}
        ])
        closeModal()
    }
    
    // useEffect(() => {
    //     console.log(taxes)
    // },[taxes])
  return (
    <div>
        {
            isOpen ?
            <div className="popup-overlay">
                <div className="popup-modal">
                <button className="close-btn" onClick={closeModal}>×</button>
                <h2 className="modal-title">Enter Tax Details</h2>
             
                    <div className="input-group">
                    <label htmlFor="field1">Enter Tax Name</label>
                    <input type="text" id="field1" placeholder="Enter Tax Name" 
                     onChange={(e) => setkey(e.target.value)}
                    />
                    </div>
                    <div className="input-group">
                    <label htmlFor="field2">Enter Tax Percentage</label>
                    <input type="text" id="field2" placeholder="Enter Tax Percentage in numbers" 
                     onChange={(e) => setValue(e.target.value)}
                    />
                    </div>
                    <button className="submit-btn" onClick={addTax}>Submit</button>
               
                </div>
            </div>
                :null
        }
    </div>
  )
}

export default PopUp
